import Footer from "./Footer";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { Mail, ArrowUpRight } from "lucide-react";

interface SupportProps {
  changeLanguage: (lang: string) => void;
}

const reveal = {
  hidden: { opacity: 0, y: 32 },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
      delay: i * 0.12,
      ease: [0.16, 1, 0.3, 1] as [number, number, number, number],
    },
  }),
};

function Support({ changeLanguage: _changeLanguage }: SupportProps) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col w-full relative bg-[#fffefd] min-h-screen">
      {/* Hero section */}
      <section className="flex-1 flex flex-col px-6 md:px-20 py-24 md:py-32">
        {/* Title + subtitle — top left */}
        <motion.div
          initial="hidden"
          animate="visible"
          className="max-w-3xl text-left"
        >
          <motion.h1
            custom={0}
            variants={reveal}
            className="text-4xl md:text-[4.25rem] font-gnarly-semibold leading-[1.05] tracking-tight text-neutral-900 mb-6 md:mb-8 text-left"
          >
            {t("support_title")}
          </motion.h1>

          <motion.p
            custom={1}
            variants={reveal}
            className="text-base md:text-xl font-gnarly-regular leading-relaxed text-neutral-500 max-w-xl"
          >
            {t("support_description")}
          </motion.p>
        </motion.div>

        {/* Button — centered */}
        <motion.div
          initial="hidden"
          animate="visible"
          className="flex-1 flex items-center justify-center"
        >
          <motion.a
            custom={2}
            variants={reveal}
            href="mailto:support@flateroo.com"
            className="group inline-flex items-center gap-4 bg-neutral-900 text-white font-gnarly-semibold text-lg px-8 py-4 rounded-full transition-all duration-300 hover:bg-neutral-800 hover:gap-5"
          >
            <Mail className="w-5 h-5" />
            support@flateroo.com
            <ArrowUpRight className="w-5 h-5 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </motion.a>
        </motion.div>
      </section>

      <Footer />
    </div>
  );
}

export default Support;
